export default {
  buttons: {
    login: 'Autentificare',
  },
  feedback: {
    incorrect_code: 'Codul introdus este incorect. Te rugăm să încerci din nou.',
    expired_code: 'Acest cod a expirat. Te rugăm să soliciți unul nou.',
    too_many_attempts: 'Prea multe încercări. Așteaptă puțin și încearcă din nou.',
    unknown: 'A apărut o eroare la verificarea codului. Te rugăm să încerci din nou.',
    network_error: 'Nu am putut contacta serverul. Verifică conexiunea și încearcă din nou.',
  },
};
